import Crud from '../views/Simbolo/Crud'
import Entity from '../views/Simbolo/Add'
import View from '../views/Simbolo/View'

let routes = {
    path: '/simbolos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/simbolos/add',
            name: 'NewSimbolo',
            component: Entity,
            meta: {
                pageTitle: 'Criação de Simbolo',
                breadcrumb: [
                    {
                        text: 'Simbolos',
                        active: false,
                        to: '/simbolos',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/simbolos/edit/:id?',
            name: 'EditSimbolo',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Simbolo',
                breadcrumb: [
                    {
                        text: 'Simbolos',
                        active: false,
                        to: '/simbolos',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/simbolos/view/:id?',
            name: 'ViewSimbolo',
            component: View,
            meta: {
                pageTitle: 'Visualizar Simbolo',
                breadcrumb: [
                    {
                        text: 'Simbolos',
                        active: false,
                        to: '/simbolos',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/simbolos',
            name: 'list-simbolos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Simbolos',
                breadcrumb: [
                    {
                        text: 'Simbolos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
